const toggleSingleStepTabs = () => {
  const builder = document.querySelector("#product-builder");

  if (!builder || !window.CPB || typeof CPB.getStore !== "function") return;

  const state = CPB.getStore().getState();
  const panels = state?.Product?.panels || [];

  if (panels.length <= 1) {
    builder.classList.add("cpb-single-step-product");
    console.log("Only 1 or less STEPS");
  } else {
    builder.classList.remove("cpb-single-step-product");
    console.log("2 or more STEPS");
  }
};

const initSingleStepTabsFix = () => {
  toggleSingleStepTabs();

  setTimeout(toggleSingleStepTabs, 300);
  setTimeout(toggleSingleStepTabs, 1000);
  setTimeout(toggleSingleStepTabs, 2000);
};

document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", initSingleStepTabsFix);
document.body.addEventListener("CPB_ON_OPTIONS_UPDATE", initSingleStepTabsFix);